window.alert = (function () {
    // Set nativeAlert
    let nativeAlert = window.alert;

    // See what to return
    return function (message) {

        // Check if it's a datatable warning
        if (message.indexOf('DataTables warning') === 0) {
            // Use toast and console instead of alert
            Vue.toasted.error('Er is iets misgegaan. Probeer het later opnieuw.');
            console.error(message);
        } else {
            // No datatable use nativeAlert
            nativeAlert(message);
        }
    };
})();

// Fetch ajax errors
$(document).ajaxError((event, request) => {

    // Check if status is 401
    if (request.status === 401) {

        // Reload top window so middleware takes over authentication
        window.top.location.reload();
    }
});
